import { Button } from "primereact/button";
import React from "react";
import { UserInfo } from "./UserInfo.template";

const TopBar = ({ toggleSidebar, loggedInItems, userDetails }) => {
  return (
    <div className="flex align-items-center justify-content-between fixed w-full p-2 border-bottom-1 border-primary-100 surface-100 shadow-1 z-1">
      <div className="flex align-items-center gap-2">
        <div className="flex align-items-center gap-2">
          <img
            alt="Saharanpur Nagar Nigam"
            src={require("assets/logos/snn-logo.png")}
            height="35"
          />

          <img
            alt="Government of UP"
            src={require("assets/logos/Seal_of_Uttar_Pradesh.svg").default}
            height="35"
            className="mr-2"
          />

          <Button size="large" text icon="pi pi-bars" onClick={toggleSidebar} />
        </div>
      </div>

      <div className="flex align-items-center justify-content-center gap-2">
        {loggedInItems.map((item) => (
          <Button
            key={item.label}
            rounded
            outlined
            size="small"
            onClick={item.command}
            title={item.label}
            icon={item.icon}
          />
        ))}
        <UserInfo userDetails={userDetails} />
      </div>
    </div>
  );
};

export default TopBar;
